import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
export function Testimonials() {
  return <section className="flex flex-col md:flex-row min-h-[500px] md:min-h-[600px]" data-id="element-277">
      {/* Image Side */}
      <div className="w-full md:w-2/5 lg:w-[45%] h-[40vh] md:h-auto relative overflow-hidden" data-id="element-278">
        <img src="https://images.unsplash.com/photo-1522413452208-996ff3f3e740?w=1200&q=80" alt="Wedding celebration detail" className="w-full h-full object-cover scale-105" data-id="element-279" />
        <div className="absolute inset-0 bg-copper/10 mix-blend-multiply" data-id="element-280" />
      </div>

      {/* Quote Side */}
      <div className="w-full md:w-3/5 lg:w-[55%] bg-warm-200 texture-linen flex items-center relative" data-id="element-281">
        {/* Corner Accents */}
        <div className="absolute top-6 left-6 md:top-10 md:left-10 w-10 h-10 md:w-14 md:h-14 border-t border-l border-copper/25" data-id="element-282" />
        <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 w-10 h-10 md:w-14 md:h-14 border-b border-r border-copper/25" data-id="element-283" />

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="px-8 py-16 md:px-16 lg:px-20 xl:px-24 relative z-10 max-w-2xl" data-id="element-284">
          <Ornament variant="flourish" color="#B87333" opacity={0.3} className="w-20 mb-6" data-id="element-285" />

          <span className="font-serif text-8xl text-copper/15 leading-none block mb-[-1.5rem]" data-id="element-286">
            &ldquo;
          </span>

          <blockquote className="font-serif text-2xl md:text-3xl lg:text-4xl text-charcoal leading-relaxed italic mb-10" data-id="element-287">
            Copper Crest made our wedding day feel like a dream we never wanted
            to wake from. Every detail was pure magic.
          </blockquote>

          <div className="w-12 h-[1px] bg-copper mb-6" data-id="element-288" />
          <p className="font-sans text-sm tracking-widest uppercase text-charcoal font-medium" data-id="element-289">
            Sarah & James
          </p>
          <p className="font-sans text-xs tracking-widest uppercase text-muted mt-2" data-id="element-290">
            Autumn Wedding 2024
          </p>
        </motion.div>
      </div>
    </section>;
}